import React from 'react';

export class ToggleButton extends React.Component {

    state = { value: this.props.value };

    trueText = this.props.trueText;
    falseText = this.props.falseText;

    onToggle = (sender) => {
        var newValue = this.props.onToggle();
        this.setState({ value: newValue });
    }

    render() {

        var labelText = this.state.value ? this.trueText : this.falseText;
        var sliderClass = this.state.value ? "slider on" : "slider off";

        return (
            <div class="toggle-container">
                <span class="toggle-text">{labelText}</span>
                <input type="checkbox" checked={this.state.value } />
                <label class="toggle" >
                    <span class={sliderClass} onclick={this.onToggle}></span>
                </label>
            </div>
        );
    }
}
